import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IndustrialLogisticsLeaders() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="14650" id="our-operational-scope" className="w-full bg-background text-foreground overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-[600px] lg:h-[800px]">
        {}
        <div className="w-full lg:w-[60%] relative h-[400px] lg:h-auto overflow-hidden group">
          <div className="absolute inset-0 bg-primary/10 z-10 mix-blend-multiply pointer-events-none" />
          <img src="https://mutual-wasp.10web.cloud/wp-content/uploads/2026/03/Vnexus-delivery.png" alt="Venchandlers Nexus maritime operations at Atlantic terminal" className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105 grayscale-[0.5] contrast-125 brightness-75" />
          {}
          <div className="absolute bottom-0 left-0 w-full h-2 bg-primary z-20" />
          <div className="absolute top-0 right-0 w-2 h-full bg-primary z-20 hidden lg:block" />
        </div>

        {}
        <div className="w-full lg:w-[40%] flex flex-col justify-center p-8 md:p-12 lg:p-16 xl:p-20 relative bg-background">
          <div ref={ref} className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}
            }`}>
            {}
            <div className="relative mb-2 select-none">
              <span className="text-[4rem] md:text-[5rem] lg:text-[6rem] leading-none font-mono font-bold text-transparent [-webkit-text-stroke:1px_hsl(var(--primary)/0.15)] absolute -top-24 -left-4 md:-left-8 z-0 whitespace-nowrap">
                10°N 66°W
              </span>
            </div>

            <div className="relative z-10">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold uppercase tracking-tight mb-8 text-foreground">
                Operational <span className="text-primary">Excellence</span>
              </h2>

              <div className="space-y-6 text-lg md:text-xl font-sans text-foreground/80 tracking-normal leading-[1.6]">
                <p>
                  Founded on decades of maritime experience, Venchandlers Nexus is an independent maritime brokerage and coordination firm led by professionals who understand the heartbeat of global trade. We specialize in the precise orchestration of ship supplies and brokerage for commercial vessels.
                </p>
                <p>
                  From the busy locks of the Panama Canal to the deep-water ports of the Atlantic, we connect vessels with trusted maritime suppliers and technical service providers through our global network. We ensure your vessel remains mission-ready by facilitating seamless coordination across the maritime supply chain.
                </p>
              </div>

              <div className="mt-10 pt-6 border-t border-border/40">
                <Button asChild size="lg" className="uppercase tracking-widest font-bold text-xs h-12 px-8 bg-primary text-primary-foreground hover:bg-primary/90 shadow-xl rounded-sm">
                  <Link to="#request-quote-home">EXPLORE OUR SERVICE</Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}